module.exports = __webpack_public_path__ + "img/topold2.433abec0.png";